import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import { Modal } from 'react-responsive-modal'
import { imgProxy } from '../../utils/helpers'
import * as profileActions from '../../containers/SignInPage/actions'
import { useDispatch, useSelector } from 'react-redux'
import {
  AchievementItemType,
  InitialState,
} from '../../containers/SignInPage/types'
import * as htmlToImage from 'html-to-image'
import { VKShareButton } from 'react-share'
import { v1 as uuidv1 } from 'uuid'

// Styles
import './styles.scss'

// Icons
import IconSponsors from './images/iconSponsors'
import Loading from '../Loading'
import IconDownload from '../ModalAchievement/images/iconDownload'
import IconVK from '../ModalAchievement/images/iconVK'
import IconClose from '../ModalFiles/images/iconClose'
import IconLogo from './images/iconLogo'
import IconPhoto from './images/iconPhoto'

export default ({
  achievement,
  modal,
  type,
  onClose,
}: {
  achievement: AchievementItemType | null
  modal: boolean
  type: 'download' | 'share'
  onClose: () => void
}) => {
  const [selectedColor, setSelectedColor] = useState<number>(0)
  const [fio, setFio] = useState<string>('')
  const [downloadIsProcess, setDownloadIsProcess] = useState<boolean>(false)

  const refButtonVk = useRef<HTMLButtonElement | null>(null)

  const dispatch = useDispatch()

  const { REACT_APP_SHARE_ACHIEVEMENT_VK_URL } = process.env

  const { profile, isProcessUploadAchievementScreenshot, achievementUrlImage } =
    useSelector((state: { profile: InitialState }) => state.profile)

  useEffect(() => {
    if (!isProcessUploadAchievementScreenshot && downloadIsProcess) {
      setDownloadIsProcess(false)
    }
  }, [isProcessUploadAchievementScreenshot])

  useEffect(() => {
    if (achievementUrlImage && downloadIsProcess) {
      refButtonVk.current?.click()
      setDownloadIsProcess(false)
    }
  }, [achievementUrlImage])

  useEffect(() => {
    if (profile && profile.profile) {
      const wrapFio = []
      if (profile.profile.last_name) {
        wrapFio.push(profile.profile.last_name)
      }
      if (profile.profile.first_name) {
        wrapFio.push(profile.profile.first_name)
      }
      if (profile.profile.middle_name) {
        wrapFio.push(profile.profile.middle_name)
      }
      setFio(wrapFio.join(' '))
    }
  }, [profile])

  const modalDownloadStyles = {
    root: {
      zIndex: 99999,
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.4)',
    },
    modal: {
      width: 805,
      borderRadius: 50,
      padding: 0,
      margin: '2em',
      boxShadow: 'unset',
      overflow: 'unset',
      outline: 0,
      background: 'transparent',
    },
  }

  const colors = [
    { id: 0, color: '#FFF', background: '#FFF', backgroundBox: '#E8E8E8' },
    {
      id: 1,
      color: '#F4BA27',
      background: '#FDECC4',
      backgroundBox: 'rgba(244, 186, 39, 0.15)',
    },
    {
      id: 2,
      color: '#219321',
      background: '#DEEFDE',
      backgroundBox: 'rgba(33, 147, 33, 0.15)',
    },
    {
      id: 3,
      color: '#1978B2',
      background: '#DDEBF4',
      backgroundBox: 'rgba(25, 120, 178, 0.15)',
    },
    {
      id: 4,
      color: '#E84E25',
      background: '#FCE5DF',
      backgroundBox: 'rgba(232, 78, 37, 0.15)',
    },
  ]

  const activeColor = colors.find(color => color.id === selectedColor)

  if (!achievement) return null

  const sendScreenshot = (file: Blob) => {
    const screenshot = new File([file], 'achievement.png')
    dispatch(
      profileActions.uploadAchievementScreenshot(
        achievement.achievement_id,
        screenshot
      )
    )
  }

  const shareScreenshot = (file: Blob) => {
    const screenshot = new File([file], 'achievement.png')
    dispatch(
      profileActions.shareAchievementScreenshot(
        achievement.achievement_id,
        screenshot
      )
    )
  }

  const handleDownloadImage = () => {
    setDownloadIsProcess(true)
    const element = document.getElementById('caption')
    if (element) {
      htmlToImage
        .toPng(element, { cacheBust: true })
        .then(() => {
          htmlToImage
            .toPng(element, { cacheBust: true })
            .then(dataUrlDouble => {
              fetch(dataUrlDouble)
                .then(res => res.blob())
                .then(blob =>
                  type === 'download'
                    ? sendScreenshot(blob)
                    : shareScreenshot(blob)
                )
            })
            .catch(error => {
              console.error('Cannot take screenshot: ', error)
            })
        })
        .catch(error => {
          console.error('Cannot take screenshot: ', error)
        })
    } else {
      setDownloadIsProcess(false)
    }
  }

  return (
    <Modal
      open={modal}
      showCloseIcon={false}
      styles={modalDownloadStyles}
      onAnimationEnd={() => setSelectedColor(0)}
      onClose={onClose}
      center={true}
    >
      <div className={'modal-download'}>
        <button className={'modal__close'} onClick={onClose}>
          <IconClose />
        </button>
        <div
          id={'caption'}
          className={'modal-download__outer'}
          style={{ backgroundColor: activeColor?.background || '#FFF' }}
        >
          <div className={'modal-download__header'}>
            <div className={'left'}>
              <div
                className={'left__outer'}
                style={{
                  backgroundColor: activeColor?.backgroundBox || '#E8E8E8',
                }}
              >
                {profile ? (
                  <>
                    <div className={'left__outer-photo'}>
                      {profile.external_profile.avatar_url ? (
                        <div
                          className={'avatar'}
                          style={{
                            backgroundImage: `url(${imgProxy(
                              profile.external_profile.avatar_url,
                              200,
                              200
                            )})`,
                          }}
                        />
                      ) : (
                        <IconPhoto width={85} height={85} />
                      )}
                    </div>
                    <div className={'left__outer-fio'}>{fio}</div>
                  </>
                ) : null}
              </div>
            </div>
            <div className={'right'}>
              <div className={'right__outer'}>
                <IconLogo />
              </div>
            </div>
          </div>
          <div
            className={'modal-download__box'}
            style={{
              backgroundColor: activeColor?.backgroundBox || '#E8E8E8',
            }}
          >
            <div
              className={'modal-download__box-image'}
              style={{
                backgroundImage: achievement.image_media
                  ? `url(${imgProxy(achievement.image_media.url, 400, 400)})`
                  : 'unset',
              }}
            />
            <div className={'modal-download__box-text'}>
              <div className={'title'}>
                Получил достижение «{achievement.caption}»
              </div>
              <div className={'time'}>
                {achievement.user_achievement?.created_at
                  ? moment(achievement.user_achievement.created_at).format(
                      'D MMMM YYYY года'
                    )
                  : null}
              </div>
            </div>
          </div>
          <div className={'modal-download__sponsors'}>
            <div className={'modal-download__sponsors-outer'}>
              <IconSponsors />
            </div>
          </div>
        </div>
        <div className={'modal-download__nav'}>
          <div className={'colors'}>
            <div className={'colors__label'}>
              Выбери
              <br />
              цвет
            </div>
            {colors.map(color => (
              <div
                key={color.id}
                className={
                  selectedColor === color.id
                    ? 'colors__item active'
                    : 'colors__item'
                }
                onClick={() => setSelectedColor(color.id)}
                style={{
                  backgroundColor: color.color,
                  border: color.id ? 'none' : '1px solid #000',
                }}
              />
            ))}
          </div>
          <div
            className={'modal-download__nav-button'}
            onClick={handleDownloadImage}
          >
            {downloadIsProcess ? (
              <Loading
                width={47}
                height={47}
                color={
                  activeColor?.color === '#FFF' ? '#333' : activeColor?.color
                }
              />
            ) : (
              <>
                {type === 'download' ? (
                  <>
                    <IconDownload style={{ marginRight: 15 }} />
                    Скачать
                  </>
                ) : (
                  <div className="modal-download__nav-button__vk">
                    <IconVK style={{ marginRight: 15 }} />
                    Поделиться
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <VKShareButton
        ref={refButtonVk}
        url={REACT_APP_SHARE_ACHIEVEMENT_VK_URL}
        image={`${achievementUrlImage}?ver=${uuidv1()}`}
        // title={`Прохожу курс и собираю достижения. Достижение «${achievement.caption}» стало моим`}
        title={`В процессе изучения истории своей семьи на ${REACT_APP_SHARE_ACHIEVEMENT_VK_URL}${
          achievement.share_description
            ? `. ${achievement.share_description}`
            : ''
        }`}
        className="modal-download__nav-button__vk"
        noParse={true}
      >
        <></>
      </VKShareButton>
    </Modal>
  )
}
